module.exports = __webpack_public_path__ + "img/support-icon.238d41f1.svg";